import styled, { keyframes } from 'styled-components';

import { Button } from '@poliedro/tamentai';
import { Select } from '@poliedro/tamentai-088';

import { StyledSelectProps } from '../types';

export const lightglow = keyframes`
  0% {
    border-bottom-color: rgba(255, 39, 255, 0.1);
    box-shadow:
      5px -5px 10px -5px rgba(18, 255, 164, 0.1),
      -5px 5px 10px -5px hsla(64, 100%, 54%, 0.1),
      10px 10px 10px -5px rgba(255, 39, 255, 0.1),
      -10px -5px 10px -5px rgba(52, 150, 255, 0.1);
  }
  33% {
    border-color: hsla(168, 97%, 58%, 0.1);
    box-shadow:
      -10px 15px 10px -5px hsla(168, 97%, 58%, 0.1),
      -5px 5px 10px -5px hsla(64, 100%, 54%, 0.1),
      15px -5px 50px -5px rgba(238, 17, 238, 0.1),
      -5px 5px 10px -5px rgba(25, 136, 228, 0.1);
  }
  66% {
    border-bottom-color: rgba(245, 38, 100, 0.1);
    box-shadow:
      -10px 5px 15px -10px hsla(209, 92%, 50%, 0.1),
      15px -5px 15px -10px rgba(241, 14, 241, 0.1),
      10px 10px 15px -5px rgba(245, 38, 100, 0.1),
      -10px -5px 10px -5px rgba(52, 150, 255, 0.1);
  }
  100% {
    border-bottom-color: rgba(255, 39, 255, 0.1);
    box-shadow:
      5px -5px 10px -5px rgba(18, 255, 164, 0.1),
      -5px 5px 10px -5px hsla(64, 100%, 54%, 0.1),
      10px 10px 10px -5px rgba(255, 39, 255, 0.1),
      -10px -5px 10px -5px rgba(52, 150, 255, 0.1);
  }
`;

export const Modal = styled.div`
  width: 28rem;
  max-width: 90vw;
  height: fit-content;
  background: #fff;
  border-radius: 20px;
  border: 1px solid #ccc;
  outline: none;
  overflow: visible;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  animation: ${lightglow} 10s ease-in-out infinite;
  transition: 0.5s;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

export const StyledButton = styled(Button)`
  margin-top: 50px;
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  align-self: end;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 16px;
  margin-top: 32px;
`;

export const StyledSelect = styled(Select)<StyledSelectProps>`
  ${props =>
    props.isPlaceholder &&
    `
    background-color: #FCFCFC !important;
  `}
`;
